/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProviderSearchResult } from './ProviderSearchResult';
import {
    ProviderSearchResultFromJSON,
    ProviderSearchResultFromJSONTyped,
    ProviderSearchResultToJSON,
} from './ProviderSearchResult';

/**
 * 
 * @export
 * @interface SearchProviderDirectoryResponse
 */
export interface SearchProviderDirectoryResponse {
    /**
     * 
     * @type {Array<ProviderSearchResult>}
     * @memberof SearchProviderDirectoryResponse
     */
    data: Array<ProviderSearchResult>;
    /**
     * 
     * @type {number}
     * @memberof SearchProviderDirectoryResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof SearchProviderDirectoryResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof SearchProviderDirectoryResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof SearchProviderDirectoryResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the SearchProviderDirectoryResponse interface.
 */
export function instanceOfSearchProviderDirectoryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function SearchProviderDirectoryResponseFromJSON(json: any): SearchProviderDirectoryResponse {
    return SearchProviderDirectoryResponseFromJSONTyped(json, false);
}

export function SearchProviderDirectoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchProviderDirectoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ProviderSearchResultFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function SearchProviderDirectoryResponseToJSON(value?: SearchProviderDirectoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(ProviderSearchResultToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

